import script from "./WangEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./WangEditor.vue?vue&type=script&setup=true&lang=js"

import "./WangEditor.vue?vue&type=style&index=0&id=76774450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76774450"]])

export default __exports__